module.exports = __webpack_public_path__ + "static/media/bmc.698a4242.png";